routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.teachingSubjects', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/subjects',
    views: {
      '': {
        template: require('./subjects/list/index.html')
      },
      'principal@': {
        template: require('./subjects/list/subjectsList.html'),
        controller: 'SubjectsListCtrl',
        controllerAs: 'subjectsListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Planear la asignatura',
      order: 1,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.listActivities',
          order: 2
        },
        {
          name: 'workplan.consultCalendar',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.teaching,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.teaching', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/subjects',
    views: {
      '': {
        template: require('./subjects/list/index.html')
      },
      'principal@': {
        template: require('./subjects/list/subjectsList.html'),
        controller: 'SubjectsListCtrl',
        controllerAs: 'subjectsListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Docencia',
      order: 1,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.listActivities',
          order: 2
        },
        {
          name: 'workplan.consultCalendar',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.teaching,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.listActivities', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/listActivities',
    views: {
      '': {
        template: require('./activities/listActivities/index.html')
      },
      'principal@': {
        template: require('./activities/listActivities/activitiesList.html'),
        controller: 'ActivitiesListCtrl',
        controllerAs: 'activitiesVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Otras actividades',
      order: 2,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.teachingSubjects',
          order: 1
        },
        {
          name: 'workplan.consultCalendar',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.teaching,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.createActivity', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/createActivity/:activityId',
    template: require('./activities/createActivity/createActivity.html'),
    controller: 'CreateActivityCtrl',
    controllerAs: 'createActivityVm',
    data: {
      displayName: 'Otras actividades',
      order: 2,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.teachingSubjects',
          order: 1
        },
        {
          name: 'workplan.consultCalendar',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.consultCalendar', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/consultCalendar/',
    views: {
      '': {
        template: require('./studentAttention/consultCalendar/index.html')
      },
      'principal@': {
        template: require('./studentAttention/consultCalendar/consultCalendar.html'),
        controller: 'ConsultCalendarCtrl',
        controllerAs: 'consultCalendarVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Programar tiempos de atención a estudiantes',
      order: 3,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.teachingSubjects',
          order: 1
        },
        {
          name: 'workplan.listActivities',
          order: 2
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.teaching,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.listSchedule', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/listSchedules',
    template: require('./studentAttention/listSchedules/scheduleList.html'),
    controller: 'ScheduleListCtrl',
    controllerAs: 'schedulesListVm',
    data: {
      displayName: 'Programar tiempos de atención a estudiantes',
      order: 5,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.teachingSubjects',
          order: 1
        },
        {
          name: 'workplan.listActivities',
          order: 2
        },
        {
          name: 'workplan.history',
          order: 6
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.planSubject', {
    moduleId: GlobalConfig.modules.teaching,
    abstract: false,
    url: '/teaching/planSubject/:subjectId',
    template: require('./subjects/plan/planSubject.html'),
    controller: 'PlanSubjectCtrl',
    controllerAs: 'subjectVm',
    data: {
      displayName: 'Planear la asignatura',
      order: 1,
      title: 'Docencia',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.listActivities',
          order: 2
        },
        {
          name: 'workplan.consultCalendar',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 4
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/teaching.route.js